import { CN_AUTH_API } from "../config/config";

function unwrap(payload) {
  return payload?.data && typeof payload.data === "object"
    ? payload.data
    : payload;
}

async function post(endpoint, body = {}) {
  if (!CN_AUTH_API) {
    throw new Error("China authentication API is not configured.");
  }
  const response = await fetch(`${CN_AUTH_API}${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  const data = unwrap(payload);
  if (!response.ok || payload?.error || data?.error) {
    throw new Error(data?.message || data?.error || "请求失败，请稍后重试");
  }
  return data;
}

export const sendPhoneCode = (phoneNumber) =>
  post("/auth/phone/code", { phoneNumber });

export const loginWithPhone = (phoneNumber, verifyCode) =>
  post("/auth/phone/login", { phoneNumber, verifyCode });

export const startWechatLogin = () => post("/auth/wechat/web/start");

export const finishWechatLogin = (code, state) =>
  post("/auth/wechat/web/login", { code, state });

export const checkCnRelay = ({ flow, relayId, loginTicket, pairingCode }) =>
  post("/auth/user/relay/check", {
    flow,
    relayId,
    ...(flow === "callback" ? { loginTicket } : { pairingCode }),
  });

export const saveCnRelay = ({
  flow,
  relayId,
  loginTicket,
  pairingCode,
  tokens,
}) =>
  post("/auth/user/relay/save", {
    flow,
    relayId,
    ...(flow === "callback" ? { loginTicket } : { pairingCode }),
    idToken: tokens.idToken,
    accessToken: tokens.accessToken,
    refreshToken: tokens.refreshToken,
  });
